export default {
    async reload() {
        if (typeof window !== 'undefined')
            window.location.reload(true);
    },
};
//# sourceMappingURL=ExpoUpdates.web.js.map